import React, { Component } from 'react';
import Header from './components/Header'
import KeyFeatures from './components/KeyFeatures'
import WalletGroup from './components/WalletGroup';
import Simplify from './components/Simplify'
import './style.css';

import { header, lastPart, contentsWallet, contentsIntegrate, collabIntegrate, keyFeature } from './components/data';
class Accountants extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Header content={header.accountant} />

        <WalletGroup contents={[contentsWallet.accountant, contentsIntegrate.accountant, collabIntegrate.accountant]} />

        <KeyFeatures data={keyFeature.accountant} />

        <Simplify content={lastPart.accountant} />
      </div>
    );
  };
}

export default Accountants;
